import { Children, memo } from "react"
import { Box, Divider } from "@mui/material"

interface IVendorImageProps {
    imageList?: any
}
const VendorImageList = (props: IVendorImageProps) => {
    const { imageList } = props

    return (
        <Box display={"flex"} sx={{justifyContent:"center"}}>
            <Box display={"flex"} flexWrap={"wrap"} mt={"40px"} gap={'2rem'} mb={"40px"}>
                {imageList?.length > 0 ? Children.toArray(imageList?.map((item: any, index: number) => {
                    return (
                        <Box key={index + 1}>
                            <img src={item?.url} style={{ width: "320px", height: "240px" }} alt={`image-list-${index}`} />
                        </Box>
                    )
                })):null}
            </Box>
            {imageList?.length ?
                <Divider />
                : null
            }
        </Box>
    )
}

export default memo(VendorImageList)